"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryBleedStars = exports.tryBleedDust = exports.tryBleed = exports.tryDropItemAtSameLocation = exports.createNearby = exports.flingCreature = exports.flingCreatureTowardsEntity = exports.flingCreatureTowardsPlayer = exports.flingRigidBodyRandomly = exports.flingPuckRandomly = exports.flingCreatureRandomly = exports.stop = exports.calcFlingStrength = exports.say = exports.hurt = exports.tryGetFromHandle = exports.isInactive = exports.renderAt = exports.render = exports.renderAll = exports.hasEffect = exports.getEffect = exports.addEffect = exports.updatePhysicsTick = exports.fadeOutNoHealthnemies = exports.killAll = exports.kill = exports.removeDead = exports.updateAllPhysicsTick = exports.create = exports.getById = exports.getAll = void 0;
var diveColors_1 = require("@dive/colors/diveColors");
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var randoInstanced_1 = require("@dive/to-engine/randoInstanced");
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var vecUtil_sidecar_1 = require("@lib/vecUtil-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var minigolfCamera_sidecar_1 = require("../camera/minigolfCamera-sidecar");
var minigolfColors_1 = require("../defs/minigolfColors");
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var minigolfPhysics_rapier_loader_sidecar_1 = require("../physics/minigolfPhysics_rapier_loader-sidecar");
var spritesBattlescapePieces_1 = require("../recyclers/spritesBattlescapePieces");
var minigolfRenderer_sidecar_1 = require("../renderer/minigolfRenderer-sidecar");
var minigolfGameState_sidecar_1 = require("../simulation/minigolfGameState-sidecar");
var syncedId_sidecar_1 = require("../to-engine/syncedId-sidecar");
var syncedRando_sidecar_1 = require("../to-engine/syncedRando-sidecar");
var minigolfCreatures_sidecar_1 = require("./minigolfCreatures-sidecar");
var minigolfCreaturesData_sidecar_1 = require("./minigolfCreaturesData-sidecar");
var minigolfEntitiesUtils_sidecar_1 = require("./minigolfEntitiesUtils-sidecar");
var minigolfFloatingTexts_sidecar_1 = require("./minigolfFloatingTexts-sidecar");
var battlescapeRenderer_sidecar_1 = require("../levelgen/battlescapeRenderer-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function getById(id) {
    for (var i = 0; i < objs.length; i++) {
        if (objs[i].id === id) {
            return objs[i];
        }
    }
    return null;
}
exports.getById = getById;
var create = function (x, y, data) {
    var phys = minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.get();
    var puckRadius = minigolfDefs_sidecar_1.minigolfDefs.puckRadius, puckLinearDamping = minigolfDefs_sidecar_1.minigolfDefs.discLinearDamping, puckAngularDamping = minigolfDefs_sidecar_1.minigolfDefs.discAngularDamping, CollisionGroups = minigolfDefs_sidecar_1.minigolfDefs.CollisionGroups;
    // Create a dynamic rigid-body.
    var block_rigidBodyDesc = null;
    if (data.isFixed) {
        block_rigidBodyDesc = phys.RA.RigidBodyDesc.fixed()
            .setTranslation(x, y)
            .setCcdEnabled(true)
            .setCanSleep(true);
    }
    else {
        block_rigidBodyDesc = phys.RA.RigidBodyDesc.dynamic()
            .setTranslation(x, y)
            .setCcdEnabled(true)
            .setLinearDamping(1.5) // 1.5)
            .setAngularDamping(2)
            .setCanSleep(true);
    }
    var block_rigidBody = phys.world.createRigidBody(block_rigidBodyDesc);
    // Create a cuboid collider attached to the dynamic rigidBody.
    // const collisionEvents = 1 //     COLLISION_EVENTS = 1,
    var size = puckRadius * 0.9;
    var sizeScale = data.size;
    size *= sizeScale * data.physicsSizeScale;
    var block_colliderDesc = null;
    if (data.shape === 'circle') {
        block_colliderDesc = phys.RA.ColliderDesc.ball(size)
            // .setRestitution(0.1)
            // .setFriction(0.99)
            .setRestitution(minigolfDefs_sidecar_1.minigolfDefs.discRestitution)
            .setFriction(minigolfDefs_sidecar_1.minigolfDefs.discFriction)
            // .setActiveEvents(collisionEvents)
            .setActiveEvents(phys.RA.ActiveEvents.COLLISION_EVENTS)
            .setDensity(data.density);
    }
    if (data.shape === 'square') {
        if (data.roundedShape) {
            block_colliderDesc = phys.RA.ColliderDesc.roundCuboid(size, size, size * 0.05)
                .setRestitution(0.1)
                .setFriction(0.99)
                // .setActiveEvents(collisionEvents)
                .setActiveEvents(phys.RA.ActiveEvents.COLLISION_EVENTS)
                .setDensity(data.density);
        }
        else {
            block_colliderDesc = phys.RA.ColliderDesc.cuboid(size, size)
                .setRestitution(0.1)
                .setFriction(0.99)
                // .setActiveEvents(collisionEvents)
                .setActiveEvents(phys.RA.ActiveEvents.COLLISION_EVENTS)
                .setDensity(data.density);
        }
    }
    // if(data.shape === 'none') {
    //   block_colliderDesc = phys.RA.ColliderDesc.cuboid(size, size)
    //   .setRestitution(0.1)
    //   .setFriction(0.99)
    //   // .setActiveEvents(collisionEvents)
    //   .setActiveEvents(phys.RA.ActiveEvents.COLLISION_EVENTS)
    //   .setDensity(data.density)
    //   .setco
    // }
    if (data.shape === 'triangle') {
        if (data.roundedShape) {
            var cd = phys.RA.ColliderDesc.roundConvexHull(
            // or roundConvexHull
            //new Float32Array([-size, size, size, -size, size, size]),
            new Float32Array([-size, -size, size, size, size, -size]), size * 0.05);
            // phys.RA.ColliderDesc.rou
            assert_sidecar_1.assert.notNil(cd, 'invalid convex hull');
            block_colliderDesc = cd
                .setRestitution(0.1)
                .setFriction(0.99)
                // .setActiveEvents(collisionEvents)
                .setActiveEvents(phys.RA.ActiveEvents.COLLISION_EVENTS)
                .setDensity(data.density);
        }
        else {
            var cd = phys.RA.ColliderDesc.convexHull(
            // or roundConvexHull
            //new Float32Array([-size, size, size, -size, size, size]),
            new Float32Array([-size, -size, size, size, size, -size]));
            // phys.RA.ColliderDesc.rou
            assert_sidecar_1.assert.notNil(cd, 'invalid convex hull');
            block_colliderDesc = cd
                .setRestitution(0.1)
                .setFriction(0.99)
                // .setActiveEvents(collisionEvents)
                .setActiveEvents(phys.RA.ActiveEvents.COLLISION_EVENTS)
                .setDensity(data.density);
        }
    }
    assert_sidecar_1.assert.notNil(block_colliderDesc, 'need a collider!');
    if (data.isSensor) {
        block_colliderDesc.setSensor(true);
    }
    var block_collider = phys.world.createCollider(block_colliderDesc, block_rigidBody);
    block_collider.setCollisionGroups(data.collisionGroups);
    var id = 0;
    if (!id) {
        id = syncedId_sidecar_1.syncedId.synced_createId();
    }
    // puck_rigidBody.setact
    var obj = {
        // player,
        rigidBody: block_rigidBody,
        isDead: false,
        eType: 'voy-misc',
        id: id,
        idLoaded: 0,
        data: data,
        state: {
            slowImmuneThisTurn: false,
            health: data.maxHealth,
            deathTime: 0,
            movedThisTurn: false,
            wasHitThisTurn: false,
            effects: [],
            isDying: false,
            tag: '',
            isFadingOut: false,
            fadeOutTimer: 0,
            torchOffsetX: 0,
            torchOffsetY: 0,
            torchAlphaOffset: 0,
        },
    };
    block_rigidBody.userData = { type: 'creature', puck: obj };
    objs.push(obj);
    if (data.autoDoom > 0) {
        exports.addEffect(obj, {
            timeLeft: data.autoDoom,
            type: 'doom',
            vec: { x: 0, y: 0 },
        });
    }
    return obj;
};
exports.create = create;
var updateAllPhysicsTick = function () {
    // Sort by render order
    objs.sort(function (a, b) { return a.data.renderOrder - b.data.renderOrder; });
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        exports.updatePhysicsTick(puck);
    }
    // checkForAllStill()
    removeDead();
};
exports.updateAllPhysicsTick = updateAllPhysicsTick;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        var phys = minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.get();
        phys.world.removeRigidBody(c.rigidBody);
        // c.rigidBody = null as any
    });
}
exports.removeDead = removeDead;
var kill = function (obj) {
    obj.isDead = true;
};
exports.kill = kill;
var killAll = function () {
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        exports.kill(puck);
    }
};
exports.killAll = killAll;
var fadeOutNoHealthnemies = function () {
    for (var i = 0; i < objs.length; i++) {
        var obj = objs[i];
        if (obj.isDead || obj.state.isFadingOut) {
            continue;
        }
        if (obj.data.isEnemy && obj.state.health <= 0) {
            obj.state.isFadingOut = true;
            obj.state.fadeOutTimer = 0;
        }
    }
};
exports.fadeOutNoHealthnemies = fadeOutNoHealthnemies;
var updatePhysicsTick = function (obj) {
    if (obj.isDead) {
        return;
    }
    if (obj.state.isFadingOut) {
        obj.state.fadeOutTimer += 1 * minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.timestep;
        if (obj.state.fadeOutTimer > 1) {
            // Just killed
            if (obj.data.onDeath === 'spawn-blob-mini') {
                exports.createNearby(obj, minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData.enemyBlobMini);
                exports.createNearby(obj, minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData.enemyBlobMini);
            }
            if (obj.data.onDeath === 'drop-item') {
                var didDrop = rando_sidecar_1.rando.chance(obj.data.dropChance);
                if (didDrop) {
                    var datas = minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData;
                    var bonuses = [];
                    randoInstanced_1.addWeighted(bonuses, datas.bonusFood, 5);
                    randoInstanced_1.addWeighted(bonuses, datas.bonusHealth, 5);
                    randoInstanced_1.addWeighted(bonuses, datas.bonusHealth2, 5);
                    randoInstanced_1.addWeighted(bonuses, datas.bonusSword, 2.5);
                    randoInstanced_1.addWeighted(bonuses, datas.bonusMoney, 2.5);
                    var bonus = rando_sidecar_1.rando.sampleWeighted(bonuses);
                    exports.tryDropItemAtSameLocation(obj, bonus);
                }
            }
            if (obj.data.onDeath === 'drop-item-lesser') {
                var didDrop = rando_sidecar_1.rando.chance(obj.data.dropChance);
                if (didDrop) {
                    var datas = minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData;
                    var bonuses = [];
                    randoInstanced_1.addWeighted(bonuses, datas.bonusFood, 5);
                    randoInstanced_1.addWeighted(bonuses, datas.bonusHealth, 5);
                    randoInstanced_1.addWeighted(bonuses, datas.bonusMoney, 2.5);
                    var bonus = rando_sidecar_1.rando.sampleWeighted(bonuses);
                    exports.tryDropItemAtSameLocation(obj, bonus);
                }
            }
            exports.kill(obj);
        }
        return;
    }
    if (obj.data.hasHealth) {
        if (obj.state.health <= 0) {
            if (!obj.state.isDying) {
                obj.state.isDying = true;
                if (obj.data.letter) {
                    minigolfGameState_sidecar_1.minigolfGameState.get().playerState.killedList += obj.data.letter;
                }
                obj.state.deathTime += 1 * minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.timestep;
                if (obj.state.deathTime > 0.25 &&
                    minigolfEntitiesUtils_sidecar_1.minigolfEntitiesUtils.checkIsStill(obj)) {
                    // kill(obj)
                }
                else if (obj.state.deathTime > 1) {
                    // kill(obj)
                }
            }
        }
        else {
            obj.state.deathTime = 0;
        }
    }
    if (obj.state.effects.length > 0) {
        for (var i = 0; i < obj.state.effects.length; i++) {
            var effect = obj.state.effects[i];
            effect.timeLeft -= 1 * minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.timestep;
            if (effect.timeLeft <= 0) {
                if (effect.type === 'doom') {
                    console.log('doom death');
                    if (obj.data.dropChance > 0) {
                        if (rando_sidecar_1.rando.chance(obj.data.dropChance) ||
                            minigolfDefs_sidecar_1.minigolfDefs.debug_testAlwaysDrop) {
                            console.log('drop bonus 1');
                            var datas = minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData;
                            var bonuses = [];
                            randoInstanced_1.addWeighted(bonuses, datas.bonusFood, 10);
                            randoInstanced_1.addWeighted(bonuses, datas.bonusHealth, 2.5);
                            randoInstanced_1.addWeighted(bonuses, datas.bonusHealth2, 2.5);
                            randoInstanced_1.addWeighted(bonuses, datas.bonusSword, 1.5);
                            randoInstanced_1.addWeighted(bonuses, datas.bonusMoney, 1.5);
                            var bonus = rando_sidecar_1.rando.sampleWeighted(bonuses);
                            exports.tryDropItemAtSameLocation(obj, bonus);
                        }
                    }
                    exports.kill(obj);
                }
                obj.state.effects.splice(i, 1);
                i--;
            }
            else {
                if (effect.type === 'ghosted') {
                    obj.rigidBody.applyImpulse(effect.vec, true);
                    // Rotate vector
                    effect.vec = vecUtil_sidecar_1.vecUtil.rotate(effect.vec, 10 * minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.timestep);
                }
                if (effect.type === 'slowed') {
                    obj.state.slowImmuneThisTurn = true;
                    var slowVec = obj.rigidBody.linvel();
                    slowVec = vecUtil_sidecar_1.vecUtil.scale(slowVec, -1);
                    slowVec = vecUtil_sidecar_1.vecUtil.scale(slowVec, 0.005);
                    // console.log(
                    //   'slowVec',
                    //   slowVec,
                    //   effect.timeLeft,
                    //   obj.rigidBody.linvel(),
                    // ) //, obj.rigidBody.
                    obj.rigidBody.applyImpulse(slowVec, true);
                }
                if (effect.type === 'stuck') {
                    var slowVec = obj.rigidBody.linvel();
                    slowVec = vecUtil_sidecar_1.vecUtil.scale(slowVec, -1);
                    slowVec = vecUtil_sidecar_1.vecUtil.scale(slowVec, 0.025);
                    // console.log(
                    //   'slowVec',
                    //   slowVec,
                    //   effect.timeLeft,
                    //   obj.rigidBody.linvel(),
                    // ) //, obj.rigidBody.
                    obj.rigidBody.applyImpulse(slowVec, true);
                }
            }
        }
    }
};
exports.updatePhysicsTick = updatePhysicsTick;
var addEffect = function (obj, effect, sound) {
    if (sound === void 0) { sound = null; }
    var existing = exports.getEffect(obj, effect.type);
    if (existing) {
        // Refresh
        if (effect.timeLeft > existing.timeLeft) {
            existing.timeLeft = effect.timeLeft;
            return;
        }
    }
    else {
        obj.state.effects.push(effect);
        if (sound) {
            sound();
        }
        if (obj.data.isPuck) {
            if (!effect.ignoreMssage) {
                if (effect.type === 'ghosted') {
                    exports.say(obj, 'confused');
                }
                if (effect.type === 'slowed') {
                    exports.say(obj, 'slowed');
                }
            }
        }
    }
};
exports.addEffect = addEffect;
var getEffect = function (obj, effectType) {
    var existing = obj.state.effects.find(function (e) { return e.type === effectType; });
    return existing || null;
};
exports.getEffect = getEffect;
var hasEffect = function (obj, effectType) {
    var existing = exports.getEffect(obj, effectType);
    if (existing) {
        return true;
    }
    return false;
};
exports.hasEffect = hasEffect;
var renderAll = function () {
    for (var i = 0; i < objs.length; i++) {
        var obj = objs[i];
        exports.render(obj);
    }
};
exports.renderAll = renderAll;
var render = function (obj) {
    var pos = minigolfRenderer_sidecar_1.minigolfRenderer.getPhysicsPosition(obj.rigidBody);
    exports.renderAt(pos.x, pos.y, pos.rotation, exports.isInactive(obj), obj.data, obj.state);
    // if (minigolfDefs.debugMp_showDiscIds) {
    //   diveFont.writeAbsolute(
    //     pos.x + 10,
    //     pos.y + 40,
    //     'id' + obj.id,
    //     0.5,
    //     diveColors.darkBlue,
    //   )
    // }
};
exports.render = render;
var renderAt = function (
// player: ICrokinolePlayer,
x, y, rotation, ghost, data, state) {
    var alpha = data.colorAlpha || 1;
    if (state.isFadingOut) {
        alpha *= mathUtils_sidecar_1.mathUtils.lerp(1, 0, state.fadeOutTimer / 1);
    }
    if (state.isDying) {
        alpha *= 0.75;
    }
    if (data.hasDisc) {
        var scaling_1 = 78 / 121;
        var sprite = spritesBattlescapePieces_1.spritesBattlescapePieces.getNext(x, y, sprites_sidecar_1.sprites.crokinoleDiscPlain[0]);
        sprite.tint = data.colorDisc; //minigolfColors.MinigolfColors[0].tint // player.color
        sprite.rotation = -rotation;
        sprite.scale = sprite.scale * scaling_1 * data.size;
        sprite.alpha = alpha;
    }
    // Main graphic
    // let scaling = (78 / 121) * 1.6
    var scaling = data.imageScale;
    if (data.letter) {
        var letterOffset = data.letterOffset || 0;
        var letterOffsetY = data.letterOffsetY || 0;
        var letterSize = 1;
        if (data.size < 1) {
            letterSize *= data.size;
        }
        diveFont_sidecar_1.diveFont.writeAbsolute(x - 6 + letterOffset, y + letterOffsetY, data.letter, letterSize, data.colorLetter);
    }
    else {
        var frame = data.frames[0];
        if (data.frames.length > 1 && data.isAnimatedTile) {
            frame =
                data.frames[battlescapeRenderer_sidecar_1.battlescapeRenderer.getFrameCounter() % data.frames.length];
        }
        if (data.isBreakable) {
            if (state.health < data.maxHealth) {
                frame = data.frames[1] || data.frames[0];
            }
        }
        var spriteSymbol = spritesBattlescapePieces_1.spritesBattlescapePieces.getNext(x, y, frame);
        spriteSymbol.tint = diveColors_1.diveColors.pureWhite;
        spriteSymbol.rotation = -rotation;
        spriteSymbol.scale = spriteSymbol.scale * scaling;
        spriteSymbol.alpha = alpha;
    }
    if (data.hasTorch) {
        // console.log(battlescapeRenderer.getFrameCounter())
        if (battlescapeRenderer_sidecar_1.battlescapeRenderer.getDidTickOverFlame()) {
            var torchShuffle = 7;
            state.torchOffsetX = Math.floor(rando_sidecar_1.rando.fs(torchShuffle));
            state.torchOffsetY = Math.floor(rando_sidecar_1.rando.fs(torchShuffle));
            state.torchAlphaOffset = rando_sidecar_1.rando.fs(1);
        }
        var spriteTorch = spritesBattlescapePieces_1.spritesBattlescapePieces.getNext(x + state.torchOffsetX, y + state.torchOffsetY, sprites_sidecar_1.sprites.minigolfTorchEffect[0]);
        spriteTorch.tint = diveColors_1.diveColors.pureWhite;
        spriteTorch.rotation = -rotation;
        spriteTorch.scale = spriteTorch.scale * scaling;
        spriteTorch.alpha = 0.25 + 0.1 * state.torchAlphaOffset;
    }
    // Render hearts
    if (data.hasHealth || data.isPuck) {
        var numHearts = state.health;
        if (data.isPuck) {
            numHearts = minigolfGameState_sidecar_1.minigolfGameState.get().playerState.health;
        }
        if (data.isMimic) {
            if (state.health === data.maxHealth) {
                numHearts = 0; // Don't show mimic hearts
            }
        }
        var i = 0;
        var hx = x;
        while (numHearts > 0 && i++ < 10) {
            var frame = sprites_sidecar_1.sprites.minigolfHeart[0];
            if (numHearts >= 2) {
                numHearts -= 2;
            }
            else {
                frame = sprites_sidecar_1.sprites.minigolfHeartHalf[0];
                numHearts -= 1;
            }
            var spriteHeart = spritesBattlescapePieces_1.spritesBattlescapePieces.getNext(hx, y + 20, frame);
            hx += 14;
            spriteHeart.tint = diveColors_1.diveColors.pureWhite; // player.color
            spriteHeart.rotation = 0;
            spriteHeart.scale *= 0.5;
        }
    }
    // Render any statuses
    var status = '';
    if (data.isPuck) {
        var isFirstLevel = minigolfGameState_sidecar_1.minigolfGameState.get().playerState.dungeonLevel <= 1;
        if (isFirstLevel) {
            status = 'You, our hero';
        }
    }
    if (data.name) {
        if (!state.isDying) {
            if (data.isMimic) {
                if (state.health < data.maxHealth) {
                    status = data.name;
                }
            }
            else {
                status = data.name;
            }
        }
    }
    if (data.pickupType) {
        var isFirstLevel = minigolfGameState_sidecar_1.minigolfGameState.get().playerState.dungeonLevel <= 1;
        if (isFirstLevel) {
            if (data.pickupType === 'stairs-down') {
                status = 'To next level';
                if (state.tag) {
                    status = state.tag;
                }
            }
            if (data.pickupType === 'food') {
                status = 'Food';
            }
        }
        if (data.pickupType === 'stairs-up') {
            if (!minigolfGameState_sidecar_1.minigolfGameState.get().playerState.hasAmulet) {
                status = 'Need amulet!';
            }
        }
        if (data.pickupType === 'amulet') {
            status = 'Amulet of Yendor';
        }
    }
    if (status) {
        diveFont_sidecar_1.diveFont.writeAbsolute(x - 20, y + 30, status, 0.5, diveColors_1.diveColors.lightBlue);
    }
};
exports.renderAt = renderAt;
var isInactive = function (obj) {
    return obj.isDead; // || puck.isOffBoard || puck.isDiscarded
};
exports.isInactive = isInactive;
var tryGetFromHandle = function (handle) {
    for (var i = 0; i < objs.length; i++) {
        var obj = objs[i];
        if (obj.rigidBody.handle === handle) {
            return obj;
        }
        if (obj.rigidBody.collider(0).handle === handle) {
            return obj;
        }
    }
    return null;
};
exports.tryGetFromHandle = tryGetFromHandle;
var hurt = function (obj, damage, damageMessage, force, sound) {
    // TODO: only if players turn?
    if (damage === void 0) { damage = 1; }
    if (damageMessage === void 0) { damageMessage = ''; }
    if (force === void 0) { force = false; }
    if (sound === void 0) { sound = null; }
    if (obj.data.isPuck) {
        if (minigolfGameState_sidecar_1.minigolfGameState.get().playerState.health < 0) {
            return;
        }
        if (!force && minigolfCreatures_sidecar_1.minigolfCreatures.hasEffect(obj, 'invulnerable')) {
            console.log('damage dodged due to iframes');
            return; // iframes
        }
        else {
            // Add invulnerability
            if (!force) {
                minigolfCreatures_sidecar_1.minigolfCreatures.addEffect(obj, {
                    timeLeft: 1 / (10 - 1),
                    type: 'invulnerable',
                    vec: { x: 0, y: 0 },
                });
            }
            minigolfGameState_sidecar_1.minigolfGameState.get().playerState.health -= damage;
            if (sound) {
                sound();
            }
            if (damageMessage === 'hunger') {
                var strings = ['so hungry', 'starving', 'famished', 'ravenous'];
                var displayString = rando_sidecar_1.rando.sample(strings);
                exports.say(obj, displayString);
            }
            else {
                exports.tryBleed(obj); // Don't bleed if hungry
                if (!damageMessage) {
                    var strings = ['ouch', 'ow!', 'ack'];
                    var displayString = rando_sidecar_1.rando.sample(strings);
                    exports.say(obj, displayString);
                }
                else {
                    exports.say(obj, damageMessage);
                }
            }
            if (damageMessage) {
                minigolfGameState_sidecar_1.minigolfGameState.get().playerState.lastDamage = damageMessage;
            }
        }
        return;
    }
    if (obj.data.hasHealth) {
        if (obj.state.health <= 0) {
            return;
        }
        if (force || minigolfGameState_sidecar_1.minigolfGameState.isPlayersTurn()) {
            if (sound) {
                sound();
            }
            obj.state.health -= damage;
            exports.tryBleed(obj);
            if (obj.state.health <= 0) {
            }
            var strings = obj.data.damagedSayings;
            if (strings.length > 0) {
                var displayString = rando_sidecar_1.rando.sample(strings);
                exports.say(obj, displayString, minigolfColors_1.palApollo.gray600);
            }
            // kill(obj)
        }
    }
};
exports.hurt = hurt;
var say = function (obj, message, color) {
    if (color === void 0) { color = diveColors_1.diveColors.pureWhite; }
    var pos = obj.rigidBody.translation();
    var cc = minigolfCamera_sidecar_1.minigolfCamera.physicsToCamera(pos.x, pos.y);
    minigolfFloatingTexts_sidecar_1.minigolfFloatingTexts.create(cc.x, cc.y, message, color);
};
exports.say = say;
var calcFlingStrength = function (moveStrength, density) {
    if (density === void 0) { density = 1; }
    return (moveStrength || 1) * density;
};
exports.calcFlingStrength = calcFlingStrength;
var stop = function (obj, immediate) {
    if (immediate === void 0) { immediate = false; }
    if (immediate) {
        obj.rigidBody.setLinvel({ x: 0, y: 0 }, true);
    }
    exports.addEffect(obj, { type: 'stuck', timeLeft: 0.5, vec: vecUtil_sidecar_1.vecUtil.create(0, 1) });
};
exports.stop = stop;
var flingCreatureRandomly = function (obj, strength) {
    if (strength === void 0) { strength = 0; }
    strength = strength || obj.data.moveStrength;
    var ss = exports.calcFlingStrength(strength, obj.data.density);
    exports.flingRigidBodyRandomly(obj.rigidBody, ss);
};
exports.flingCreatureRandomly = flingCreatureRandomly;
var flingPuckRandomly = function (obj, strengthScale) {
    exports.flingRigidBodyRandomly(obj.rigidBody, strengthScale);
};
exports.flingPuckRandomly = flingPuckRandomly;
var flingRigidBodyRandomly = function (rigidBody, strengthScale) {
    var rando = syncedRando_sidecar_1.syncedRando.getSyncedImportantRando();
    var turns = rando.f(0, 1);
    var strength = rando.f(0.5 * strengthScale, 1 * strengthScale);
    var vec = vecUtil_sidecar_1.vecUtil.fromTurns(turns, strength);
    rigidBody.applyImpulse(vec, true);
};
exports.flingRigidBodyRandomly = flingRigidBodyRandomly;
var flingCreatureTowardsPlayer = function (obj) {
    var player = minigolfGameState_sidecar_1.minigolfGameState.get().currentPuck;
    if (!player) {
        exports.flingCreatureRandomly(obj);
        return;
    }
    exports.flingCreatureTowardsEntity(obj, player);
};
exports.flingCreatureTowardsPlayer = flingCreatureTowardsPlayer;
var flingCreatureTowardsEntity = function (obj, target) {
    if (!target) {
        exports.flingCreatureRandomly(obj);
        return;
    }
    var vec = vecUtil_sidecar_1.vecUtil.deltaTowardsXY(obj.rigidBody.translation(), target.rigidBody.translation(), 1);
    // Add some inaccuracy
    vec = vecUtil_sidecar_1.vecUtil.rotateTurns(vec, syncedRando_sidecar_1.syncedRando.getSyncedImportantRando().fs(0.06));
    vec = vecUtil_sidecar_1.vecUtil.normalizeSafe(vec);
    var ss = exports.calcFlingStrength(obj.data.moveStrength, obj.data.density);
    vec = vecUtil_sidecar_1.vecUtil.scale(vec, ss);
    obj.rigidBody.applyImpulse(vec, true);
};
exports.flingCreatureTowardsEntity = flingCreatureTowardsEntity;
var flingCreature = function (obj, direction, moveStrength) {
    var vec = vecUtil_sidecar_1.vecUtil.normalizeSafe(direction);
    var ss = exports.calcFlingStrength(moveStrength, obj.data.density);
    vec = vecUtil_sidecar_1.vecUtil.scale(vec, ss);
    obj.rigidBody.applyImpulse(vec, true);
};
exports.flingCreature = flingCreature;
var createNearby = function (obj, data) {
    var pos = obj.rigidBody.translation();
    var randomSpacing = vecUtil_sidecar_1.vecUtil.create(0, 1);
    randomSpacing = vecUtil_sidecar_1.vecUtil.rotateTurns(randomSpacing, rando_sidecar_1.rando.f(0, 1));
    var scale = rando_sidecar_1.rando.f(0.01, 0.02);
    randomSpacing = vecUtil_sidecar_1.vecUtil.scale(randomSpacing, scale * 10);
    var bonusItem = exports.create(pos.x + randomSpacing.x, pos.y + randomSpacing.x, data);
    // TODO: check and see if this is a valid placement or try again
    // bonusItem.rigidBody.setLinvel(obj.rigidBody.linvel(), true)
    // flingCreatureRandomly(bonusItem, 0.1)
    // console.log('drop bonus 2', bonusItem)
    return bonusItem;
};
exports.createNearby = createNearby;
var tryDropItemAtSameLocation = function (obj, bonus) {
    var pos = obj.rigidBody.translation();
    var bonusItem = exports.create(pos.x, pos.y, bonus);
    bonusItem.rigidBody.setLinvel(obj.rigidBody.linvel(), true);
    exports.flingCreatureRandomly(bonusItem, 0.1);
    console.log('drop bonus 2', bonusItem);
};
exports.tryDropItemAtSameLocation = tryDropItemAtSameLocation;
var tryBleed = function (obj, overrideBlood) {
    if (overrideBlood === void 0) { overrideBlood = ''; }
    var pos = obj.rigidBody.translation();
    var bleeds = overrideBlood || obj.data.bleeds;
    if (!bleeds) {
        return;
    }
    var data = minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData.particleBlood;
    if (bleeds === 'lava') {
        data = minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData.particleLava;
    }
    if (bleeds === 'slime') {
        data = minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData.particleSlime;
    }
    if (bleeds === 'spectral') {
        data = minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData.particleSpectral;
    }
    if (bleeds === 'wood') {
        data = minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData.particleWood;
    }
    var num = rando_sidecar_1.rando.i(1, 3);
    for (var i = 0; i < num; i++) {
        var randomSpacing = vecUtil_sidecar_1.vecUtil.create(0, 1);
        randomSpacing = vecUtil_sidecar_1.vecUtil.rotateTurns(randomSpacing, rando_sidecar_1.rando.f(0, 1));
        var scale = rando_sidecar_1.rando.f(0.01, 0.02);
        randomSpacing = vecUtil_sidecar_1.vecUtil.scale(randomSpacing, scale * 5);
        var bloodParticle = exports.create(pos.x + randomSpacing.x, pos.y + randomSpacing.y, data);
        bloodParticle.rigidBody.setLinvel(obj.rigidBody.linvel(), true);
        var power = rando_sidecar_1.rando.f(0.05, 0.2);
        exports.flingCreatureRandomly(bloodParticle, power);
        console.log('drop blood', bloodParticle);
    }
};
exports.tryBleed = tryBleed;
var tryBleedDust = function (obj) {
    var pos = obj.rigidBody.translation();
    var data = minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData.particleDust;
    var num = rando_sidecar_1.rando.i(1, 2);
    for (var i = 0; i < num; i++) {
        var randomSpacing = vecUtil_sidecar_1.vecUtil.create(0, 1);
        randomSpacing = vecUtil_sidecar_1.vecUtil.rotateTurns(randomSpacing, rando_sidecar_1.rando.f(0, 1));
        var scale = rando_sidecar_1.rando.f(0.01, 0.02);
        randomSpacing = vecUtil_sidecar_1.vecUtil.scale(randomSpacing, scale * 5);
        var bloodParticle = exports.create(pos.x + randomSpacing.x, pos.y + randomSpacing.y, data);
        // bloodParticle.rigidBody.setLinvel(obj.rigidBody.linvel(), true)
        var power = rando_sidecar_1.rando.f(0.01, 0.02);
        exports.flingCreatureRandomly(bloodParticle, power);
        console.log('drop dust', bloodParticle);
    }
};
exports.tryBleedDust = tryBleedDust;
var tryBleedStars = function (obj) {
    var pos = obj.rigidBody.translation();
    var data = minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData.particleStar;
    var num = rando_sidecar_1.rando.i(1, 4);
    for (var i = 0; i < num; i++) {
        var randomSpacing = vecUtil_sidecar_1.vecUtil.create(0, 1);
        randomSpacing = vecUtil_sidecar_1.vecUtil.rotateTurns(randomSpacing, rando_sidecar_1.rando.f(0, 1));
        var scale = rando_sidecar_1.rando.f(0.01, 0.02);
        randomSpacing = vecUtil_sidecar_1.vecUtil.scale(randomSpacing, scale * 5);
        var bloodParticle = exports.create(pos.x + randomSpacing.x, pos.y + randomSpacing.y, data);
        // bloodParticle.rigidBody.setLinvel(obj.rigidBody.linvel(), true)
        var power = rando_sidecar_1.rando.f(0.01, 0.02);
        exports.flingCreatureRandomly(bloodParticle, power);
        console.log('drop dust', bloodParticle);
        exports.addEffect(bloodParticle, {
            timeLeft: 0.2,
            type: 'slowed',
            vec: { x: 0, y: 0 },
        });
        exports.addEffect(bloodParticle, {
            timeLeft: 0.2,
            type: 'ghosted',
            vec: { x: 0, y: 0 },
        });
    }
};
exports.tryBleedStars = tryBleedStars;
